import { PapiDaSharedPushSettings } from '@wix/da-papi-types';

export enum PushSubscriptionState {
  // loading state, e.g. in the middle of subscribing
  LOADING = 0,
  // notifications are allowed and there's an active subscription
  SUBSCRIBED = 1,
  // either need to ask for permission to send notifications
  // and then subscribe,
  // or we have permission but not yet subscribed
  READY_TO_SUBSCRIBE = 2,
  // user explicitly denied permission, we can neither send
  // notifications nor subscribe
  UNABLE_TO_SUBSCRIBE = 3,
  // failed to subscribe or other error
  FAILED = 4,
}

export type PushSubscriptions = PapiDaSharedPushSettings['send'];

export interface PwaState {
  pushSubscriptionState: PushSubscriptionState;
  send: PushSubscriptions;
  initialized: boolean;
  hidePWABanner: boolean;
  PWAInstallPrompt: IBeforeInstallPromptEvent | null;
}

export interface IBeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
}
